"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crewUpdate = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageMessageCrewHurt_1 = require("@voyage/multi/voyageMessageCrewHurt");
var voyageMessageCrewHurt_sidecar_1 = require("@voyage/multi/voyageMessageCrewHurt-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageSystems_sidecar_1 = require("@voyage/systems/voyageSystems-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
function crewUpdate(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    var useSystemTime = 0.5;
    d.useSystemTimer += ds;
    diveCrew_hero_sidecar_1.diveCrew_hero.setProgress(obj, d.useSystemTimer / useSystemTime);
    if (d.useSystemTimer > useSystemTime) {
        d.useSystemTimer -= useSystemTime;
        if (voyageSystems_sidecar_1.voyageSystems.testNoPower(obj)) {
            return;
        }
        var tHere = voyageTilemap_sidecar_1.voyageTilemap.getSafeIJ(obj);
        if (tHere) {
            var sys = voyageTilemap_sidecar_1.voyageTilemap.getSystemByKeySafe(('' + tHere.text3).replace('pad', 'med'));
            if (sys) {
                var dr = diveCrew_sidecar_1.diveCrew.getAtIIJ(sys, function (c) { return c.type === diveCrew_1.EVoyageCrewType.Hero; });
                // let toHeal = diveCrew.getAt(
                //   sys,
                //   (c) => c.type === EVoyageCrewType.Crew,
                // )
                if (dr && !dr.isDying) {
                    // voyageParticles.createMultiple('heal', sys.x, sys.y, 1)
                    var toHeal = obj;
                    if (toHeal && !toHeal.isDying) {
                        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                            var healRate = 10;
                            var newHitpoints = toHeal.hitpoints + useSystemTime * healRate;
                            if (newHitpoints > 125) {
                                newHitpoints = 125;
                            }
                            voyageMessageCrewHurt_sidecar_1.voyageMessageCrewHurt.sendMessageAndImmediatelyExecute({
                                crewId: toHeal.id,
                                byCrewId: dr.id,
                                newHitpoints: newHitpoints,
                                type: voyageMessageCrewHurt_1.EVoyageCrewDamageType.Heal,
                            });
                        }
                    }
                }
            }
        }
    }
}
exports.crewUpdate = crewUpdate;
